import { Component, Input, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { NgbCarousel, NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import { AdminService } from "src/app/services/admin.service";
import { PlansService } from "src/app/services/plans.service";

@Component({
  selector: 'app-plans-price',
  templateUrl: './plans-price.component.html',
  styleUrls: ['./plans-price.component.scss'],
})
export class PlansPriceComponent {
  modules: any = {};
  moduleNames: string[] = [];
  isClicked: boolean = true;
  price: any;
  id: any;
  job: any;
  planLabels:any={}
  transformDescription(description: string): string {
    return description.replace(/\n/g, '<br>');
  }
  constructor(
    private router: Router,
    private adminService: AdminService,
    private fb: FormBuilder,
    config: NgbCarouselConfig,
    private dialog: MatDialog,
    private plansService: PlansService,
  ) {}

  ngOnInit() {
    this.getPlans();
  }


  getPlans() {
    let reqObj = {};
    this.adminService.getPlans(reqObj).subscribe((response) => {
      if (response.statusCode === 200) {
        const data = response.data.plans;
        this.planLabels = response.data.labels;
        Object.keys(data).forEach(moduleName => {
          const plans = data[moduleName];
          plans.forEach(plan => {
            plan.module_name = moduleName;
  
            this.logSubPlans(plan);
  
            if (moduleName in this.modules) {
              this.modules[moduleName].push(plan);
            } else {
              this.modules[moduleName] = [plan];
            }
          });
        });
  
        this.moduleNames = Object.keys(this.modules); 
  
      } else {
        console.error("Error fetching data:", response.error);
      }
    });
  }
  
  logSubPlans(plan: any) {
    if (plan.plans && plan.plans.length > 0) {
      console.log("Sub-plans for", plan.module_name, ":", plan.plans);
      plan.plans.forEach(subPlan => {
        console.log("Sub-plan ID:", subPlan.id);
        console.log("Sub-plan Description:", subPlan.description);
      });
    }
  }
  
  

  
  goTo(plan: any) {
    this.plansService.selectedPlan = plan; // Store the selected plan object
    this.router.navigate(['product-details']);
    console.log("plan check",plan)
  }
}
